import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommandesService } from 'src/app/services/commandes/commandes.service';
import { TeamsService } from 'src/app/services/teams-cofat/teams.service';

@Component({
  selector: 'app-send-mails',
  templateUrl: './send-mails.component.html',
  styleUrls: ['./send-mails.component.css'],
})
export class SendMailsComponent implements OnInit {
  // isSaved: Boolean = true

  @Output() result = new EventEmitter<any>();

  @Input() cmd: any;
  @ViewChild('emailContent') emailContentRef!: ElementRef<HTMLDivElement>;
  emailHtml = '';

  @Input() cmds: any[];
  @Input() providerContacts: any[];
  @Input() transContacts: any[];

  form: FormGroup;

  constructor(
    private activeModal: NgbActiveModal,
    private cmdsService: CommandesService,
    private fb: FormBuilder,
    private teamsServices: TeamsService
  ) {
    this.form = fb.group({
      emails: fb.array([]),
    });
  }

  ngOnInit(): void {
    // this.addConnectedUserEmail();
    this.emailHtml = this.getEmailProviderAndTransportor(this.cmd);
  }

  copyEmail(): void {
    const el = this.emailContentRef?.nativeElement;
    if (!el) return;

    const range = document.createRange();
    range.selectNodeContents(el);

    const selection = window.getSelection();
    if (!selection) return;

    selection.removeAllRanges();
    selection.addRange(range);

    // copie le contenu sélectionné (avec la mise en forme)
    const successful = document.execCommand('copy');

    // on enlève la sélection visuelle
    selection.removeAllRanges();

    if (successful) {
      console.log('Email copied with formatting');
      // éventuellement un toast :
      // this.alert.success('COMMON.COPIED');
    } else {
      console.error('Copy command failed');
    }
  }

  get emails(): FormArray {
    return this.form.get('emails') as FormArray;
  }
  addEmail(): void {
    this.emails.push(this.fb.control('', Validators.email));
  }
  addConnectedUserEmail(): void {
    this.emails.push(
      this.fb.control(this.teamsServices.getEmail(), Validators.email)
    );
  }
  deleteEmail(index: number) {
    if (this.form.value.emails.length > 1) {
      this.emails.removeAt(index);
    }
  }

  // mergeEmails() {
  //   let contacts: any[] = []
  //   this.providerContacts.forEach(contact => {
  //     if(contact.isChecked) {
  //       contacts.push(contact?.email)
  //     }
  //   });
  //   this.transContacts.forEach(contact => {
  //     if(contact.isChecked) {
  //       contacts.push(contact?.email)
  //     }
  //   });
  //   contacts.push(...this.form.value.emails)

  //   return contacts
  // }

  emailsNotEmpty(emails: any) {
    if (emails.length == 0) return false;

    for (var i = 0; i < emails.length; i++) {
      if (emails[i] == null || emails[i] == '') return false;
    }
    return true;
  }
  sendMail() {
    var providerContacts = this.getEmails(this.providerContacts);
    // console.log(providerContacts)
    var transContacts = this.getEmails(this.transContacts);
    // console.log(transContacts)

    // var isValidate = this.emailsNotEmpty(this.form.value.emails)
    // if (!isValidate) {
    if (
      providerContacts?.length == 0 &&
      transContacts?.length == 0 &&
      !this.emailsNotEmpty(this.form.value.emails)
    ) {
      // this.isSaved = false
      alert('Merci de sélectionner la liste des emails valides !');
    } else {
      // let contacts: any[] = this.mergeEmails()

      var data = {
        object: 'Confirmation',
        cmds: this.cmds,

        providerContacts: providerContacts,
        transContacts: transContacts,
        others: this.form.value.emails,
      };
      //console.log("dataaaaaaaaaaaaa : ")
      //console.log(data)
      this.cmdsService.sendMail(data).then(async (res: any) => {
        //console.log("resssssssss : ")
        //console.log(res)
        if (res && res.response) {
          //console.log("ressssssssssssssssss");
          //console.log(res)
          this.result.emit(true);
          this.activeModal.close();
          alert('Email envoyé avec succès');
        } else {
          alert(res.msg);
        }
      });
    }
  }
  checkValue(item: any) {
    if (item == null || (item != null && item == '')) return true;
    else return false;
  }
  getEmails(array: any[]) {
    let contacts: any[] = [];
    array.forEach((contact) => {
      if (contact.isChecked) {
        contacts.push(contact?.email);
      }
    });

    return contacts;
  }

  /** === Ton template adapté en méthode TS === */
  private getEmailProviderAndTransportor(theCmd: any): string {
    const dimension = this.getDimension(theCmd);
    const nbrBoxes = this.getNbrBoxes(theCmd?.pallets || []);

    // console.log('theCmd :: ', theCmd);

    return (
      '<h4><b>Dear Sir /Madam,</b></h4>' +
      '<p>Please note that your reservation has been successfully registered.</p>' +
      `<p><b>${
        theCmd?.pickupedBy?.nameSociety || ''
      }</b> collection team, please arrange the pickup of the shipment below (documents attached) :</p>` +
      '<ul>' +
      `<li><b>Provider name :</b> ${
        theCmd?.client_cmd?.providerName || ''
      }</li>` +
      `<li><b>Pick-up reference :</b> ${theCmd?.ref_facture_cmd || ''}</li>` +
      `<li><b>Pick-up address :</b> ${
        theCmd?.client_cmd?.fullAddress
          ? theCmd.client_cmd.fullAddress
          : theCmd?.client_cmd?.adressSociety?.label_target || ''
      }</li>` +
      `<li><b>Number of pallets :</b> ${theCmd?.totalPallets || 0} pallet(s)` +
      (nbrBoxes > 0 ? ` and ${nbrBoxes} loose box(es)` : '') +
      '</li>' +
      `<li><b>Total volume (m³) :</b> ${this.formatNumber(
        theCmd?.totalVolume,
        3
      )}</li>` +
      `<li><b>Total weight (Kg) :</b> ${this.formatNumber(
        theCmd?.totalPoids,
        3
      )}</li>` +
      `<li><b>Collection Date :</b> ${
        theCmd?.pickupDate
          ? new Date(theCmd.pickupDate).toLocaleString('en-GB', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })
          : ''
      }</li>` +
      `<li><b>Stackable (yes/no) :</b> ${
        theCmd?.client_cmd?.stackable ? 'Yes' : 'No'
      }</li>` +
      `<li><b>Receiver adress :</b> ${
        theCmd?.society?.adress?.label_target || ''
      }</li>` +
      '</ul>' +
      `<b>Comment : </b>${theCmd?.comment || ''}</br></br>` +
      (dimension ? `<b>Dimensions of pallets :</b></br></br>${dimension}` : '')
    );
  }

  private getNbrBoxes(pallets: any[]): number {
    let totalQuantite = 0;
    pallets?.forEach((pallet) => {
      pallet?.boxes?.forEach((box: any) => {
        totalQuantite += box?.quantite || 0;
      });
    });
    return totalQuantite;
  }

  private getDimension(theCmd: any): string | null {
    let palletHtml = '';

    if (
      (theCmd?.genPallets?.length || 0) > 0 ||
      (theCmd?.totalPallets || 0) > 0
    ) {
      palletHtml +=
        "<table class='table table-bordered table-sm'>" +
        '<tr>' +
        '<th>#</th>' +
        '<th>Name of the pallet</th>' +
        '<th>L X l X H</th>' +
        '<th>Volume (m³)</th>' +
        '<th>Pallet Weight (Kg)</th>' +
        '<th>Quantity</th>' +
        '<th>Total Volume (m³)</th>' +
        '<th>Total Weight (Kg)</th>' +
        '</tr>';

      // ici tu réutilises tes fonctions existantes :
      palletHtml += this.getTrGenPallets(theCmd);
      palletHtml += this.getTrPallets(theCmd);

      palletHtml += '</table>';
      return palletHtml;
    }
    return null;
  }

  private getTrGenPallets(theCmd: any): string {
    let trsPallets = '';
    let volume: string;

    (theCmd?.genPallets || []).forEach((pallet: any, index: number) => {
      const depth = pallet?.dimensions?.depth ?? 0;
      const width = pallet?.dimensions?.width ?? 0;
      const height = pallet?.dimensions?.height ?? 0;

      const volNumber = depth * width * height;
      volume = this.formatNumber(volNumber, 3);

      trsPallets +=
        '<tr>' +
        `<td>${index + 1}</td>` +
        `<td>${
          pallet?.pallet_generated?.name ? pallet.pallet_generated.name : ' - '
        }</td>` +
        `<td>${this.formatNumber(depth, 2)} X ${this.formatNumber(
          width,
          2
        )} X ${this.formatNumber(height, 2)}</td>` +
        `<td>${volume}</td>` +
        `<td>${this.formatNumber(pallet?.totalWeight ?? 0, 2)}</td>` +
        `<td>1</td>` +
        `<td>${volume}</td>` +
        `<td>${this.formatNumber(pallet?.totalWeight ?? 0, 2)}</td>` +
        '</tr>';
    });

    return trsPallets;
  }

  private getTrPallets(theCmd: any): string {
    const nbrGenPallets = theCmd?.genPallets ? theCmd.genPallets.length : 0;
    let trsPallets = '';

    (theCmd?.pallets || []).forEach((pallet: any, index: number) => {
      const qty = pallet?.quantity ?? 0;
      const volume = pallet?.volume ?? 0;
      const weight = pallet?.weight ?? 0;

      trsPallets +=
        '<tr>' +
        `<td>${index + nbrGenPallets + 1}</td>` +
        `<td>${pallet?.name_pallet ?? ''}</td>` +
        `<td>${pallet?.length ?? ''} X ${pallet?.width ?? ''} X ${
          pallet?.height ?? ''
        }</td>` +
        `<td>${this.formatNumber(volume, 3)}</td>` +
        `<td>${this.formatNumber(weight, 1)}</td>` +
        `<td>${qty}</td>` +
        `<td>${this.formatNumber(qty * volume, 3)}</td>` +
        `<td>${this.formatNumber(qty * weight, 1)}</td>` +
        '</tr>';
    });

    return trsPallets;
  }

  private formatNumber(value: number | undefined, decimals = 3): string {
    if (value == null) return '';
    return value.toFixed(decimals);
  }

  closeModal() {
    this.result.emit(null);
    this.activeModal.dismiss();
  }
}
